var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiveMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 98,
    viewBox: "0 0 229 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0415 74.3906H40.3757",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6812 85.0725V63.7656",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 57.9375H13.6944",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34717 63.2744V52.5938",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.611 63.2734H226",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.306 52.5938V73.9006",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.625 79.7266H199.319",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.972 74.3906V85.0713",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.019 31.0893L111.06 38.0393L125.812 25.0772",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179.319 34.1172V94.4958",
    stroke: "#3B4858",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.451 58.3125L179.32 94.4961",
    stroke: "#3B4858",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.385 25.3438L179.32 34.1172",
    stroke: "#3B4858",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.208 69.4289L179.32 34.1172",
    stroke: "#3B4858",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0962 34.1172L115.208 69.4289",
    stroke: "#3B4858",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0962 94.4922H179.32",
    stroke: "#3B4858",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0962 34.1172V94.4958",
    stroke: "#3B4858",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.965 58.3125L51.0962 94.4961",
    stroke: "#3B4858",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0306 25.3438L51.0962 34.1172",
    stroke: "#3B4858",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M155.148 45.8862V3",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0303 3H155.148",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0303 45.8862V3",
    stroke: "#06CEA8",
    strokeWidth: 5.26051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveMail);
export default __webpack_public_path__ + "static/media/receive-mail.85296596ebea7af6992a782188e95fcc.svg";
export { ForwardRef as ReactComponent };